import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './App.css'; // ✅ now your dark mode styles will apply
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { getAuth } from 'firebase/auth';
import { flushPendingWrites } from './utils/flushPendingWrites';

serviceWorkerRegistration.register();



window.addEventListener('online', () => {
  const user = getAuth().currentUser;
  if (user) flushPendingWrites(user);
});

// Load saved theme before app mounts
(function applyInitialTheme() {
  const theme = localStorage.getItem('theme') || 'light';
  const themes = ['theme-light', 'theme-dark', 'theme-sepia', 'theme-blueprint', 'theme-custom'];
  themes.forEach(t => document.body.classList.remove(t));
  document.body.classList.add(`theme-${theme}`);

  if (theme === 'custom') {
    const bg = localStorage.getItem('customBgColor') || '#ffffff';
    const yiq = (parseInt(bg.slice(1, 3), 16) * 299 +
                 parseInt(bg.slice(3, 5), 16) * 587 +
                 parseInt(bg.slice(5, 7), 16) * 114) / 1000;
    const textColor = yiq >= 128 ? '#000000' : '#ffffff';

    document.documentElement.style.setProperty('--custom-bg', bg);
    document.documentElement.style.setProperty('--custom-text', textColor);
    document.documentElement.style.setProperty('--custom-button-bg', bg);
    document.documentElement.style.setProperty('--custom-button-text', textColor);
  }
})();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
